import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {DynamicDialogRef, DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { TermsService } from '../services/terms.service';

@Component({
  selector: 'app-terms-dialog',
  templateUrl: './terms-dialog.component.html',
  styleUrls: ['./terms-dialog.component.css'],
  providers: [TermsService]
})
export class TermsDialogComponent implements OnInit {

  public terms: any = {};
  termsAndCondition: any;

  constructor(protected termsService: TermsService, public config: DynamicDialogConfig, public ref: DynamicDialogRef, private dialogService: DialogService, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
	this.terms = this.stripUnsafeTags(this.config.data.termsOfUse);
    this.terms = this.sanitizer.bypassSecurityTrustHtml(this.terms);
  }

  stripUnsafeTags(html: string): string {
    // Define a regular expression to match unsafe HTML tags
    const unsafeTagsRegex = /<\/?(script|iframe|object|embed|form|input|button|select|textarea)\b[^>]*>/gi;

    // Remove unsafe tags from the HTML
    return html.replace(unsafeTagsRegex, '');
  }

  closeTermsAndCondition(event: Event)
  {
    event.preventDefault();
    this.ref.close();
  }

}
